import { errorExchange } from "urql";
import { createStandaloneToast } from "@chakra-ui/react";

export const { ToastContainer, toast } = createStandaloneToast();


export const commoneErrorExchange = errorExchange({
  


  onError: (error) => {
    // UnauthorizedはLogin画面でしか発生しない、かつ問題ないため toastを表示しない。
    if (error.message !== "[GraphQL] Unauthorized") {
      console.error("error detail:");
      console.error(error.message);
      toast({
        title: 'エラー',
        description: '予期しないエラーが発生しました。時間をおいて再度実行してください。',
        status: 'error',
        duration: 9000,
        isClosable: true,
      })
    }
    if (
      error.graphQLErrors.some((e) => e.message === "INTERNAL_SERVER_ERROR")
    ) {
      console.info("[commonErrorExchange] internal server error");
    }

    if (error.networkError) {
      console.error(error);
      console.info(
        "[commonErrorExchange] (network error) response:",
        error.response,
        "\nstacktrace:\n",
        error.networkError.stack
      );
    }
  },
});
